import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useState } from "react";
import { CopyBlock, dracula } from "react-code-blocks";
import LoadingButton from "../../components/LoadingButton";
import { hostname } from "../../utils";

export default ({
  open,
  onClose,
  companyId,
  chatId,
  getToken,
}: {
  open: boolean;
  onClose: () => void;
  companyId: string;
  chatId: string;
  getToken: Function;
}) => {
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);

  const createShareableLink = async () => {
    setLoading(true);
    const currentToken = await getToken();
    await axios
      .post(
        `${hostname}/chats/${companyId}/${chatId}/share`,
        {},
        {
          headers: {
            Authorization: `Bearer ${currentToken}`,
          },
        }
      )
      .then((res) => {
        setLink(`${window.location.origin}/conversation/${res.data.id}`);
      });
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Share Chat
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {link && (
          <div
            style={{
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <CopyBlock
              language={"javascript"}
              text={link}
              wrapLines
              codeBlock
              showLineNumbers={false}
              theme={dracula}
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <LoadingButton
          loading={loading}
          onClick={createShareableLink}
          variant="contained"
        >
          Create Shareable Link
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
